'use client';

import { Box } from '@terra/ui-styled-system';
import { useTranslations } from 'next-intl';
import { type TabGroupColor } from '../../../store/layoutStore';
import {
  getGroupPickerFillColor,
  TAB_GROUP_COLOR_ORDER,
  toCanonicalTabGroupColor,
} from './tabGroupDecorativeColor';

type TabGroupColorPickerProps = {
  selectedColor: TabGroupColor;
  onSelectColor: (color: TabGroupColor) => void;
};

export function TabGroupColorPicker({
  selectedColor,
  onSelectColor,
}: TabGroupColorPickerProps) {
  const t = useTranslations('layout.groupColors');
  const selectedCanonical = toCanonicalTabGroupColor(selectedColor);

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      w="full"
      px="2"
      py="1"
    >
      {TAB_GROUP_COLOR_ORDER.map((color) => {
        const isSelected = selectedCanonical === color;
        const fill = getGroupPickerFillColor(color);
        return (
          <Box
            key={color}
            role="button"
            tabIndex={0}
            aria-label={t(color)}
            display="flex"
            alignItems="center"
            justifyContent="center"
            w="4"
            h="4"
            p={isSelected ? '0.5' : '0'}
            borderRadius="full"
            borderWidth={isSelected ? '2px' : '0'}
            borderStyle="solid"
            cursor="pointer"
            flexShrink={0}
            onClick={() => onSelectColor(color)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onSelectColor(color);
              }
            }}
            _hover={{ transform: 'scale(1.1)' }}
            style={{ borderColor: isSelected ? fill : undefined }}
          >
            <Box
              w="full"
              h="full"
              borderRadius="full"
              style={{ backgroundColor: fill }}
            />
          </Box>
        );
      })}
    </Box>
  );
}
